import {
    SEND_WELCOME_EMAIL_OPEN_MODAL,
    SEND_WELCOME_EMAIL_CLOSE_MODAL,
    SEND_WELCOME_EMAIL_REQUEST,
    SEND_WELCOME_EMAIL_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    subuser: null,
    company: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SEND_WELCOME_EMAIL_OPEN_MODAL:
            return { ...state, openModal: true, subuser: action.payload.subuser, company: action.payload.company }

        case SEND_WELCOME_EMAIL_CLOSE_MODAL:
            return { ...state, openModal: false }

        case SEND_WELCOME_EMAIL_REQUEST:
            return { ...state, loading: true }

        case SEND_WELCOME_EMAIL_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "SEND_WELCOME_EMAIL"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};